import { React, lazy } from "react";
import { Route, Routes } from "react-router-dom";

// Main pages importation
const MainPage = lazy(() => import('presentation/pages/main'))
const Loader = lazy(() => import('presentation/pages/loader'))

// Section pages importation
const LandingSection = lazy(() => import('presentation/pages/main/content/landingPage'))
const BlogSection = lazy(() => import('presentation/pages/main/content/blog'))
const BlogDetailSection = lazy(() => import('presentation/pages/main/content/detailBlog'))
const TermsOfUSeSection = lazy(() => import('presentation/pages/main/content/terms/termsOfUse'))
const TermsOfPrivacy = lazy(() => import('presentation/pages/main/content/terms/termsPrivacy'))



function MainRoutes() {
  return (
      <Routes>
        <Route path="/loader" element={<Loader />} />
        <Route path="/" element={<MainPage />}>
            <Route index element={<LandingSection />} />
            <Route path="/home" element={<LandingSection />} />
            <Route path="/terms/use" element={<TermsOfUSeSection />} />
            <Route path="/policy/privacy" element={<TermsOfPrivacy />} />
            <Route path="/blog" element={<BlogSection />} />
            <Route path="/blog/:id" element={<BlogDetailSection />}/>
        </Route>
      </Routes>
  );
}

export default MainRoutes;
